const _excluded = ["money", "onChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import { TextField } from 'seagull';
import { isValidNumberWithPrecisionOf2 } from 'seagull/utils/money-input';
import Decimal from 'decimal.js';
import { moneyModel } from "../../models";
export const MoneyTextField = props => {
  const {
    money,
    onChange: _onChange
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const [value, setValue] = useState(money);
  useEffect(() => {
    setValue(money);
  }, [money]);
  return /*#__PURE__*/React.createElement(TextField, _extends({
    prefix: "$",
    value: value != null ? value.amount().toFixed() : '',
    onChange: e => {
      const dollarsAsString = e.currentTarget.value;

      if (!isValidNumberWithPrecisionOf2(dollarsAsString)) {
        return;
      }

      let newMoney = null;

      if (!dollarsAsString) {
        setValue(null);
      } else {
        const amount = new Decimal(dollarsAsString);
        newMoney = moneyModel.make(amount);
        setValue(newMoney);
      }

      if (_onChange) _onChange(newMoney);
    },
    type: "number",
    placeholder: "0.00"
  }, rest));
};